<template>
  <div class="wk_collezioni_view wrapper">
    <div class="d-flex flex-column w-100 mx-2">
      <div id="collezione-select-bar" class="d-flex align-center">
        <div class="d-flex align-center w-33">
          <span class="wk_lista-collezioni_label">Select a collection</span>
          <v-autocomplete
            :items="listaCollezioni"
            v-model="selectedCollezione"
            class="mx-3 my-0"
            auto-select-first
            clearable
            @update:model-value="goToCollezione(selectedCollezione)"
          ></v-autocomplete>
        </div>
      </div>

      <v-text-field v-if="loading">Loading...</v-text-field>

      <DataTable
        v-if="isAdmin"
        :value="collezioni"
        :reorderable-columns="true"
        @rowReorder="onRowReorder"
        v-model:editingRows="editingRows"
        editMode="row"
        @row-edit-init="onRowEditInit"
        @row-edit-save="onRowEditSave"
        @row-edit-cancel="onRowEditCancel"
        class="p-datatable-sm"
        lazy
        resizableColumns
        columnResizeMode="expand"
      >
        <ColumnGroup type="header">
          <Row>
            <Column header="" :rowspan="2" />
            <Column header="name" :rowspan="2" />
            <Column header="code" :rowspan="2" />
            <Column header="total decor" :rowspan="2" />

            <Column header="core" :colspan="4" />

            <Column header="application" :rowspan="2" />
            <Column header="" :rowspan="2" />
          </Row>

          <Row>
            <Column header="Standard" />
            <Column header="Black" />
            <Column header="Full-Colour" />
            <Column header="ReAbet" />
          </Row>
        </ColumnGroup>

        <Column
          field="index"
          rowReorder
          headerStyle="width: 6rem"
          :reorderableColumn="false"
        />

        <Column field="nome" header="name"/>

        <Column field="codice_1" header="code"/>

        <Column field="totale_decorativi" header="total decor"/>

        <Column
          field="core.standard"
          header="core"
          bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
          class="wk_column_grey"
        >
          <template #editor="{ data }">
            <Dropdown
                :options="listaCore"
                optionLabel="DESC"
                optionValue="CODE"
                v-model="data.core.standard"
            ></Dropdown>
          </template>
        </Column>

        <Column
          field="core.black"
          header="core"
          bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
          class="wk_column_grey"
        >
          <template #body="{ data }">
            <Checkbox v-model="data.core.black" binary disabled/>
          </template>
          <template #editor="{ data }">
            <Checkbox v-model="data.core.black" binary/>
          </template>
        </Column>

        <Column
          field="core.full_colour"
          header="core"
          bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
          class="wk_column_grey"
        >
          <template #body="{ data }">
            <Checkbox v-model="data.core.full_colour" binary disabled/>
          </template>
          <template #editor="{ data }">
            <Checkbox v-model="data.core.full_colour" binary/>
          </template>
        </Column>

        <Column
          field="core.re_abet"
          header="core"
          bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
          class="wk_column_grey"
        >
          <template #body="{ data }">
            <Checkbox v-model="data.core.re_abet" binary disabled/>
          </template>
          <template #editor="{ data }">
            <Checkbox v-model="data.core.re_abet" binary/>
          </template>
        </Column>

        <Column
          field="application"
          header="application"
          bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
          class="wk_column_grey"
        >
          <template #body="{ data, field }">
            {{ data[field].join(", ") }}
          </template>
          <template #editor="{ data, field }">
            <MultiSelect
              :options="['interior', 'exterior']"
              v-model="data[field]"
            ></MultiSelect>
          </template>
        </Column>
        <Column
          field="action_edit"
          :rowEditor="true"
          style="width: 50px; min-width: 8rem"
          bodyStyle="text-align:right"
        >
        </Column>
      </DataTable>

      <DataTable
          v-else
          :value="collezioni"
          class="p-datatable-sm"
          lazy
          resizableColumns
          columnResizeMode="expand"
      >
        <ColumnGroup type="header">
          <Row>
            <Column header="name" :rowspan="2" />
            <Column header="code" :rowspan="2" />
            <Column header="total decor" :rowspan="2" />

            <Column header="core" :colspan="4" />

            <Column header="application" :rowspan="2" />
            <Column header="" :rowspan="2" />
          </Row>

          <Row>
            <Column header="Standard" />
            <Column header="Black" />
            <Column header="Full-Colour" />
            <Column header="ReAbet" />
          </Row>
        </ColumnGroup>

        <Column field="nome" header="name"/>

        <Column field="codice_1" header="code"/>

        <Column field="totale_decorativi" header="total decor"/>

        <Column
            field="core.standard"
            header="core"
            bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
            class="wk_column_grey"
        />

        <Column
            field="core.black"
            header="core"
            bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
            class="wk_column_grey"
        >
          <template #body="{ data }">
            <Checkbox v-model="data.core.black" binary disabled/>
          </template>
        </Column>

        <Column
            field="core.full_colour"
            header="core"
            bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
            class="wk_column_grey"
        >
          <template #body="{ data }">
            <Checkbox v-model="data.core.full_colour" binary disabled/>
          </template>
        </Column>

        <Column
            field="core.re_abet"
            header="core"
            bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
            class="wk_column_grey"
        >
          <template #body="{ data }">
            <Checkbox v-model="data.core.re_abet" binary disabled/>
          </template>
        </Column>

        <Column
            field="application"
            header="application"
            bodyStyle="padding: 0 20px; background-color: #b7b7b72c;"
            class="wk_column_grey"
        >
          <template #body="{ data, field }">
            {{ data[field].join(", ") }}
          </template>
        </Column>
      </DataTable>
    </div>

    <v-snackbar v-model="snackbar" :timeout="2000">
      {{ text }}

      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="snackbar = false"
          >Chiudi
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<style scoped>
.wk_collezioni_view {
  font-size: 20px;
  text-transform: lowercase;
}

#collezione-select-bar {
  margin: 30px 0;
  width: 100%;
}
</style>

<script>
import axios from "axios";
import {
  API_URL,
  notifyError,
  notifyLoading,
  notifySaving,
} from "@/utils/const";
import authHeader from "@/services/data.service";
import store from "@/store";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      loading: false,
      // data from APIs
      collezioni: null,
      listaCollezioni: [],
      listaCore: [],
      selectedCollezione: null,
      editingRows: [],
      text: "",
      snackbar: false,
      application_tmp: [],
      core_tmp: []
    };
  },
  computed: {
    ...mapGetters("auth", ['isAdmin'])
  },
  async mounted() {
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title;
    }

    if (store.getters["auth/loggedIn"]) {
      await store.dispatch("auth/role").catch(() => {
        this.text = notifyError;
        this.snackbar = true;
      });
    }

    this.loading = true;
    await this.getCollezioni();
    await this.getStandardCores();
    this.loading = false;
  },
  methods: {
    async getCollezioni() {
      await axios
        .get(API_URL + "collezioni/all", { headers: authHeader() })
        .then((response) => {
          if (response.data) {
            this.collezioni = response.data;
            this.listaCollezioni = this.collezioni.map((item) => item.nome);
            this.text = notifyLoading;
            this.snackbar = true;
          }
        })
        .catch(() => {
          this.text = notifyError;
          this.snackbar = true;
        });
    },
    async getStandardCores() {
      await axios
          .get(API_URL + "core/standard", { headers: authHeader() })
        .then((response) => {
            this.listaCore = response.data;
        })
        .catch(() => {
          this.text = notifyError;
          this.snackbar = true;
        });
    },
    async updateIndex(id, index) {
      const body = { _id: id, index: index };
      await axios
        .put(API_URL + "collezioni/reorder", body, { headers: authHeader() })
        .then(() => {
          this.text = notifySaving;
          this.snackbar = true;
        })
        .catch(() => {
          this.text = notifyError;
          this.snackbar = true;
        });
    },
    async updateCore(id, core) {
      const body = {
        _id: id,
        standard: core.standard,
        black: core.black,
        full_colour: core.full_colour,
        re_abet: core.re_abet
      };

      return await axios
        .put(API_URL + "collezioni/core", body, { headers: authHeader() })
          .then(() => {
            this.text = notifySaving;
            this.snackbar = true;
            return true;
          })
          .catch(() => {
            this.text = notifyError;
            this.snackbar = true;
            return false;
          });
    },
    async updateApplication(id, application) {
      const body = {
        _id: id,
        application: application
      };

      return await axios
          .put(API_URL + "collezioni/application", body, { headers: authHeader() })
          .then(() => {
            this.text = notifySaving;
            this.snackbar = true;
            return true;
          })
          .catch(() => {
            this.text = notifyError;
            this.snackbar = true;
            return false;
          });
    },
    goToCollezione(selectedCollezione) {
      this.$router.push({ path: `/collections/${selectedCollezione}` });
    },
    onRowReorder(event) {
      this.collezioni = event.value;
      for (let i = 0; i < this.collezioni.length; i++) {
        if (i !== this.collezioni[i].index) {
          this.updateIndex(this.collezioni[i]._id, i);
          this.collezioni[i].index = i;
          console.log(
            `${this.collezioni[i].nome} has index: ${this.collezioni[i].index}`
          );
        }
      }
    },
    onRowEditInit(event) {
      let { index } = event;
      this.application_tmp[index] = this.collezioni[index]["application"];
      this.core_tmp[index] = structuredClone(this.collezioni[index]["core"]);
    },
    onRowEditCancel(event) {
      let { index } = event;
      this.collezioni[index]["application"] = this.application_tmp[index];

      this.collezioni[index]["core"]["standard"] = this.core_tmp[index]["standard"];
      this.collezioni[index]["core"]["black"] = this.core_tmp[index]["black"];
      this.collezioni[index]["core"]["full_colour"] = this.core_tmp[index]["full_colour"];
      this.collezioni[index]["core"]["re_abet"] = this.core_tmp[index]["re_abet"];

      this.application_tmp[index] = null;
      this.core_tmp[index] = null;
    },
    async onRowEditSave(event) {
      let { newData, index } = event;

      if (
          this.core_tmp[index]["standard"] !== newData.core.standard ||
          this.core_tmp[index]["black"] !== newData.core.black ||
          this.core_tmp[index]["full_colour"] !== newData.core.full_colour ||
          this.core_tmp[index]["re_abet"] !== newData.core.re_abet
      ) {
        let status = await this.updateCore(newData._id, newData.core);

        if (!status) {
          this.collezioni[index]["core"]["standard"] = this.core_tmp[index]["standard"];
          this.collezioni[index]["core"]["black"] = this.core_tmp[index]["black"];
          this.collezioni[index]["core"]["full_colour"] = this.core_tmp[index]["full_colour"];
          this.collezioni[index]["core"]["re_abet"] = this.core_tmp[index]["re_abet"];
        }
      }
      this.core_tmp[index] = null;

      if (this.application_tmp[index] !== newData.application) {
        let status = await this.updateApplication(newData._id, newData.application);

        if (!status) {
          this.collezioni[index]['application'] = this.application_tmp[index];
        } else {
          this.collezioni[index]['application'] = newData.application;
        }
      }
      this.application_tmp[index] = null;
    },
  },
};
</script>
